<template>
  <contract-discount-form
    description="Configura un descompte per a reserves amb una estada mínima determinada."
    :percentage="contractLongStayDiscount"
    percentage-label="Introudeix el percentatge"
    percentage-description="Aquest percentatge s'aplicarà a l'import propietari"
    :days="contractLongStayDiscountDuration"
    days-label="Introudeix la duració"
    days-description="Defineix els dies mínims d'estada"
    @cancel="cancel"
    @save="save"
  />
</template>

<script>
import ContractDiscountForm from "@/views/contracts/contract/components/ContractDiscountForm.vue";
import { notifyError } from "@/utils/methods";

export default {
  components: {
    ContractDiscountForm,
  },
  computed: {
    contract() {
      return this.$store.getters["contract/contract"];
    },
    contractLongStayDiscount() {
      return this.contract?.longStayDiscount || null;
    },
    contractLongStayDiscountDuration() {
      return this.contract?.longStayDiscountDuration || null;
    },
  },
  methods: {
    save(form) {
      this.$store.dispatch("app/setLoading", true);

      this.$store
        .dispatch("contract/updateContract", {
          uuid: this.contract.uuid,
          longStayDiscount: form.percentage,
          longStayDiscountDuration: form.days,
        })
        .then(() => {
          // TODO: log the contract update?
          this.$emit("updated");
        })
        .catch(() =>
          notifyError(
            "Error",
            "Hi ha hagut un error al intentar actualitzar el contracte"
          )
        )
        .finally(() => this.$store.dispatch("app/setLoading", false));
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>
